var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elements",
    d: "M6.5 15.4987V13.4154M6.5 13.4154V12.1654C6.5 11.7725 6.5 11.5761 6.62814 11.4541C6.75628 11.332 6.96252 11.332 7.375 11.332H7.95833C8.56239 11.332 9.05208 11.7984 9.05208 12.3737C9.05208 12.949 8.56239 13.4154 7.95833 13.4154H6.5ZM18.1667 11.332H17.0729C16.3855 11.332 16.0417 11.332 15.8282 11.5354C15.6146 11.7388 15.6146 12.0662 15.6146 12.7209V13.4154M15.6146 15.4987V13.4154M15.6146 13.4154H17.4375M13.7917 13.4154C13.7917 14.566 12.8123 15.4987 11.6042 15.4987C11.3316 15.4987 11.1953 15.4987 11.0937 15.4429C10.8507 15.3092 10.875 15.0387 10.875 14.8043V12.0265C10.875 11.7921 10.8507 11.5215 11.0937 11.3879C11.1953 11.332 11.3316 11.332 11.6042 11.332C12.8123 11.332 13.7917 12.2648 13.7917 13.4154Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elements_2",
    d: "M13.1673 18.832H9.60671C6.88904 18.832 5.5302 18.832 4.58654 18.1672C4.31617 17.9767 4.07613 17.7508 3.87373 17.4963C3.16732 16.6081 3.16732 15.3292 3.16732 12.7714V10.6502C3.16732 8.1809 3.16732 6.94625 3.5581 5.96016C4.18633 4.37488 5.51493 3.12443 7.19929 2.53316C8.24701 2.16536 9.55883 2.16536 12.1825 2.16536C13.6817 2.16536 14.4313 2.16536 15.03 2.37553C15.9925 2.7134 16.7517 3.42795 17.1107 4.33382C17.334 4.8973 17.334 5.60281 17.334 7.01385V8.83203",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "elements_3",
    d: "M3.16667 10.5C3.16667 8.96588 4.41032 7.72222 5.94444 7.72222C6.49926 7.72222 7.15336 7.81944 7.6928 7.6749C8.1721 7.54647 8.54647 7.1721 8.6749 6.6928C8.81944 6.15336 8.72222 5.49926 8.72222 4.94444C8.72222 3.41032 9.96588 2.16667 11.5 2.16667",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0ad3bf9ccdf3be61f68222d6a09dc467.svg";
export { ForwardRef as ReactComponent };